import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "calendar-event-card" }
const _hoisted_2 = { class: "event-header" }
const _hoisted_3 = {
  key: 0,
  class: "pub-tag"
}
const _hoisted_4 = { class: "card-section dates" }
const _hoisted_5 = { class: "card-section assignment-details details-block" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Details", -1)
const _hoisted_7 = { class: "button-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "title", {}, () => [
        _createElementVNode("span", {
          class: _normalizeClass(["event-key", _ctx.event.classNames])
        }, null, 2),
        _createElementVNode("h3", null, [
          _createElementVNode("b", null, _toDisplayString(_ctx.event.title), 1),
          (_ctx.isPublished)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Published"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "dates")
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("h3", null, [
        _renderSlot(_ctx.$slots, "content-title", {}, () => [
          _hoisted_6
        ])
      ]),
      _renderSlot(_ctx.$slots, "description"),
      _createElementVNode("div", _hoisted_7, [
        _renderSlot(_ctx.$slots, "buttons")
      ])
    ])
  ]))
}